const translations = {
  app_name: "FormWeg",
  auth: {
    username: "Benutzername oder E-Mail",
    unauthorized: "Login fehlgeschlagen",
    back_to_login: "Zurück zum Login",
    remember_me: "Merken",
    sign_in: "Anmelden",
    forgot_password: "Passwort vergessen",
    forgot_password_alert: "E-Mail mit Anweisungen zum zurücksetzen wurde versendet",
    password_confirm_error: "Passwörter müssen übereinstimmen",
    submit: "Senden",
    password: "Passwort",
    password_confirm: "Passwort wiederholen",
    reset_password_alert: "Ihr Passwort wurde zurück gesetzt",
    reset_token_expired: "Der Link ist leider abgelaufen",
    password_policy: {
      number: "Passwort muss mindestens eine Zahl enthalten",
      length: "Passwort muss mindestens 8 Zeichen lang sein",
      special: "Passwort muss mindestens ein Sonderzeichzen enthalten",
      uppercase: "Passwort muss mindestens ein Großbuchstaben enthalten",
      lowercase: "Passwort muss mindestens ein Kleinbuchstaben enthalten",
    },
  },
  menu: {
    home: "Start",
    actions: "Aktionen",
    documentation: "Dokumentation",
    documentation_short: "Doku",
    files: "Bilder & Dateien",
    note: "Notiz",
    notes: "Notizen",
    comment: "Kommentar",
    comments: "Kommentare",
    remark: "Bemerkung",
    items: "Artikel",
    users: "Benutzer",
    customers: "Kunden",
    customer_properties: "Objekte",
    help: "Hilfe",
    feedback: "Anfrage",
    settings: "Einstellungen",
    logout: "Abmelden",
    translations: "Bezeichnungen",
    integrations: "Schnittstellen",
    imports: "Importe",
    search: "Suche",
    filter: "Filter",
    all: "Alle",
    deleted: "Gelöscht",
    import: "Import",
    export: "Export",
    more: "Mehr",
    add: "Hinzufügen",
    edit: "Ändern",
    next: "Weiter",
    previous: "Zurück",
    from: "von",
    to: "bis",
    cancel: "Abbrechen",
    submit: "Speichern",
    review: "Zur Bearbeitung",
    bill: "Zur Abrechnung",
    bill_or_review: "In Bearbeitung",
    billed: "Abgerechnet",
    canceled: "Verworfen",
    inspection: "Zur Wartung",
    inspections: "Inspektionen",
    inspection_cards: "Prüfübersicht",
    drafts: "Entwürfe",
  },
  work_orders: {
    work_orders: "Arbeitsaufträge",
    work_order: "Arbeitsauftrag",
    number: "Nummer",
    add: "Arbeitsauftrag anlegen",
    status: "Status",
    created_at: "Erstellt am",
    assigned_to: "Zugewiesen an",
    assigned_at: "Zugewiesen am",
    unassigned: "Nicht zugewiesen",
    assign_to_me: "Mir zuweisen",
    create_form: "$t(delivery_notes.delivery_note) erstellen",
    open_form: "$t(delivery_notes.delivery_note) öffnen",
    choose_template: "$t(delivery_notes.templates.template) wählen",
    link_form: "$t(delivery_notes.delivery_note) verknüpfen",
    create: "Erstellen",
    link: "Verknüpfen",
    unlink: "Verknüpfung lösen",
    confirm_unlink: "Verknüpfung zu $t(delivery_notes.delivery_note) {{number}} wirklich lösen?",
    cancel: "Verwerfen",
    confirm_cancel: "$t(work_orders.work_order) wirklich verwerfen?",
    canceled_by: "Verworfen von",
    scheduled: "Ausführungstermin",
    scheduled_short: "Termin",
    scheduled_from: "Termin",
    scheduled_until: "Termin bis (optional)",
    availability: "Erreichbarkeit",
    availability_from: "Erreichbar von",
    availability_until: "Erreichbar bis (optional)",
    remark: "Informationen",
    remark_original: "Original",
    remark_summary: "Zusammenfassung",
    read_only: "Dieser Arbeitsauftrag ist nicht mehr aktiv und kann nicht mehr bearbeitet werden.",
    audit: "Historie",
    tabs: {
      open: "Offen",
      unassigned: "Unzugewiesen",
      in_progress: "In Arbeit",
      done: "Abgeschlossen",
      canceled: "Verworfen",
      all: "Alle",
    },
    states: {
      open: "Offen",
      in_progress: "In Arbeit",
      done: "Abgeschlossen",
      canceled: "Verworfen",
    },
    origin_hint: {
      sqlbase: "Aus dem Prüfintervall übernommen.",
    },
    errors: {
      already_assigned: "Dieser Arbeitsauftrag wurde bereits zugewiesen.",
      already_canceled: "Dieser Arbeitsauftrag wurde bereits verworfen.",
      already_has_active_note: "Dieser Arbeitsauftrag hat bereits ein aktives $t(delivery_notes.delivery_note).",
      already_linked: "Dieses $t(delivery_notes.delivery_note) ist bereits verknüpft.",
      availability_until_before_from: "„Erreichbar bis“ darf nicht vor „Erreichbar von“ liegen.",
      scheduled_until_before_from: "„Termin bis“ darf nicht vor „Termin“ liegen.",
      concurrent_edit: "Der Arbeitsauftrag wurde zwischenzeitlich geändert. Bitte aktualisieren und erneut versuchen.",
      customer_required: "Bitte Kunde oder Kundenadresse angeben.",
      customer_number_numeric: "Kundennummer darf nur Ziffern enthalten.",
      delivery_note_canceled: "Ein verworfenes $t(delivery_notes.delivery_note) kann nicht verknüpft werden.",
      forbidden: "Keine Berechtigung für diesen Arbeitsauftrag.",
      has_delivered_note: "Der Arbeitsauftrag kann nicht mehr verworfen werden, da bereits ein fertiggestelltes $t(delivery_notes.delivery_note) verknüpft ist.",
      invalid_assignee: "Ungültiger Techniker.",
      invalid_delivery_note: "$t(delivery_notes.delivery_note) nicht gefunden.",
      invalid_filter: "Ungültiger Filter.",
      linked_elsewhere: "Dieses $t(delivery_notes.delivery_note) ist bereits mit einem anderen Arbeitsauftrag verknüpft.",
      not_active: "Dieser Arbeitsauftrag ist nicht mehr aktiv.",
      not_found: "Arbeitsauftrag nicht gefunden.",
      not_linked: "Dieses $t(delivery_notes.delivery_note) ist nicht mit dem Arbeitsauftrag verknüpft.",
      not_open: "Dieser Arbeitsauftrag ist nicht mehr offen.",
      read_only: "Dieser Arbeitsauftrag kann nicht mehr bearbeitet werden.",
    },
  },
  items: {
    item: "Artikel",
    highlight: "In Dokumentübersicht hervorheben",
    highlight_short: "Hervorheben",

    inspect_every_x_months: "Wartungsintervall (Monate)",
    line: "Pos",
    inspect_interval_months: "Wartungsintervall in Monaten",
    items: "Artikel",
    itemp: "Artikel",
    name: "Artikel",
    amount: "Menge",
    details: "Artikel Details",
    number: "Nummer",
    description: "Beschreibung",
    attributes: {
      choice: "Option",
      menu: {
        add_choice: "Option anlegen",
        select_choice: "Option auswählen",
      },
    },
    groups: {
      group: "Gruppe",
      ungrouped: "Ohne Gruppe",
      rename: "Gruppe umbenennen",
    },

    characteristics: {
      characteristic: "Merkmal",
      different: "Mit unterschiedlichen Merkmalen",
      simular: "Mit gleichartigen Merkmalen",
      unique: "Mit einzigartigen Merkmalen",
      short: {
        different: "",
        simular: "Gleichartig",
        unique: "Einzigartig",
      },
    },
  },
  customers: {
    new: "Neuer Kunde",
    new_customer: "Neukunde",
    number: "Kunden Nr.",
    customers: "Kunden",
    customer: "Kunde",
    not_found: "Kunde nicht gefunden",
    search_unavailable: "Kundensuche nicht verfügbar da kein ERP System angebunden ist",
    service_unavailable: "SQLBase ist derzeit nicht erreichbar. Bitte prüfen Sie die Netzwerkverbindung.",
    name: "Name",
    properties: {
      search: "Objekt Suche...",
      //street: "Objekt Straße",
      //zip: "Objekt Postleitzahl",
      //city: "Objekt Stadt",
      //district: "Objekt Bezirk",
      name: "Objekt Name",
      number: "Objekt Nr.",
      properties: "Objekte",
      property: "Objekt",
      contact: "Kontakt",
      address: "Adresse",
    },

    assigned_to: "Zuständiger Prüfer",
    assign_to_me: "Mir zuweisen",
    unassigned: "Nicht zugewiesen",

    menu: {
      search: "Kunde",
      signature: "Unterschrift",
    },
  },
  contacts: {
    contact: "Kontakt",
  },
  delivery_notes: {
    delivery_notes: "Formulare",
    delivery_note: "Formular",
    cancel: "Verwerfen",
    number: "Nummer",
    date: "Datum",
    next_date_of_inspection: "Fällig",
    menu: {
      add: "Hinzufügen",
      add_2: "Anlegen",
      save: "Speichern",
      change: "Ändern",
      completed: "Fertigstellen",
      confirm_completed:
        "$t(delivery_notes.delivery_note) wirklich fertigstellen? Danach kann er nicht mehr als Entwurf bearbeitet werden.",
      confirm_reviewed: "$t(delivery_notes.delivery_note) wirklich als geprüft markieren?",
      confirm_billed: "$t(delivery_notes.delivery_note) wirklich als abgerechnet markieren?",
      confirm_canceled: "$t(delivery_notes.delivery_note) wirklich verwerfen?",
      confirm_copy: "$t(delivery_notes.delivery_note) wirklich kopieren?",
      advancing_next: "Weiter zum nächsten $t(delivery_notes.delivery_note)…",
      status: "Status",
      draft: "Speichern",
    },
    status: {
      due: "Fällig",
    },
    assigned_to: "Bearbeiter",
    assign_to_me: "Mir zuweisen",
    unassigned: "Nicht zugewiesen",
    auto_items_group: "Deine häufigsten Artikel",
    custom_group: "Eigene",
    removed_from_template: "Nicht mehr in {{name}} Vorlage enthalten",
    coworkers: "Kooperation",
    coworker_badge: "Mitarbeiter",
    performed_by: "Durchgeführt von",
    no_performer: "Kein Mitarbeiter",
    link_work_order: "$t(work_orders.work_order) verknüpfen",
    audit: "Historie",
    states: {
      drafted: "Entwurf",
      pending: "Ausstehend",
      delivered: "Geliefert",
      reviewed: "Geprüft",
      billed: "Abgerechnet",
      canceled: "Verworfen",
    },

    templates: {
      template: "Vorlage",
      templates: "Vorlagen",
      name: "Name",
      items: "Artikel",
      item_count: "Artikel",
      created_by: "Erstellt von",
      search_item: "Artikel suchen",
      no_items: "Keine Artikel zugewiesen",
      no_documentation: "Keine Dokumentation konfiguriert",
      add_column: "Spalte",
      add_field: "Feld",
      add_group: "Gruppe",
      add_field_to_group: "Feld",
      add_row: "Zeile",
      col_name: "Spaltenname",
      group_name: "Gruppenname",
      empty_group: "Keine Felder in dieser Gruppe",
      row_label: "Zeilenbeschriftung",
      default_value: "Standardwert",
      default_values: "Standardwerte",
      choices_hint: "Optionen (kommagetrennt)",
      field_unit: "Einheit (z.B. bar, cm, s)",
      document_fields: "Dokument-Felder",
      add_document_field: "Dokument-Feld",
      no_document_fields: "Keine Dokument-Felder konfiguriert",
      field_description_placeholder: "Beschreibung / Hinweis (optional)",
      widgets: {
        text: "Text",
        number: "Zahl",
        boolean: "Checkbox",
        select: "Auswahl",
        radio: "Radio",
        date: "Datum",
      },
      import_excel: {
        button: "Importieren",
        title: "Dokumentation aus Excel/CSV importieren",
        step_file: "Datei",
        step_options: "Optionen",
        step_columns: "Spalten",
        step_mapping: "Zuordnung",
        step_preview: "Vorschau",
        mode_label: "Wie soll der Import angewendet werden?",
        mode_fill: "Vorhandene Felder befüllen",
        mode_fill_hint: "Behält die konfigurierten Felder und befüllt sie mit den importierten Werten.",
        mode_replace: "Dokumentation ersetzen",
        mode_replace_hint: "Die importierten Spalten ersetzen die vorhandenen Felder und Zeilen.",
        choose_file: "Datei wählen",
        drop_hint: "Eine .xlsx-, .xls- oder .csv-Datei hier ablegen oder zum Auswählen klicken",
        file_selected: "Gewählt: {{name}}",
        parse_error: "Datei konnte nicht gelesen werden. Bitte Format prüfen.",
        use_first_row_as_headers: "Erste Zeile als Spaltenüberschriften verwenden",
        ignore_empty_columns: "Leere Spalten ignorieren",
        delimiter: "Trennzeichen (CSV)",
        delimiter_auto: "Automatisch erkennen",
        delimiter_comma: "Komma (,)",
        delimiter_semicolon: "Semikolon (;)",
        delimiter_tab: "Tab",
        delimiter_pipe: "Pipe (|)",
        sheet: "Tabellenblatt",
        no_columns: "Keine Spalten erkannt.",
        select_columns_hint: "Spalten zum Import auswählen. Alle Werte werden als Text übernommen.",
        mapping_hint: "Jede Spalte einem Feld zuordnen. Spalten mit übereinstimmenden Namen sind vorbelegt; nicht zugeordnete Spalten werden nicht importiert.",
        mapping_skip: "Nicht importieren",
        unmapped_fields: "Felder ohne importierte Daten: {{fields}}",
        empty_column: "leer",
        sample_value: "Beispiel: {{value}}",
        column_count: "{{count}} Spalten",
        row_count: "{{count}} Zeilen",
        replace_warning: "Die aktuellen Dokumentations-Spalten und -Zeilen werden ersetzt.",
        fill_warning: "Die vorhandenen Zeilen werden ersetzt. Die Felder selbst bleiben erhalten.",
        new_options_warning: "Werte, die nicht in den konfigurierten Optionen enthalten sind, werden als neue Optionen ergänzt:",
        cancel: "Abbrechen",
        back: "Zurück",
        next: "Weiter",
        replace: "Ersetzen",
        import: "Importieren",
        imported_badge: "Importiert: {{details}}",
      },
    },
    alerts: {
      reviewed: "$t(delivery_notes.delivery_note) ist bereits als geprüft markiert und kann nicht mehr verändert werden.",
      save_offline:
        "Speichern fehlgeschlagen – keine Internetverbindung. Ihre Eingaben bleiben auf dieser Seite erhalten, bitte erneut speichern, sobald wieder Empfang besteht.",
      save_offline_restored: "Verbindung wiederhergestellt – bitte erneut speichern.",
      save_conflict:
        "$t(delivery_notes.delivery_note) wurde zwischenzeitlich an anderer Stelle geändert. Bitte laden Sie die Seite neu und tragen Sie Ihre Änderungen erneut ein.",
    },
    customer: {
      no_signature: "Keine Kundenunterschrift!",
      no_signature_reason: "Keine Unterschrift, durchgeführte Arbeiten zuvor besprochen und bestätigt",
    },
    errors: {
      number_already_exists: "Artikelnummer existiert bereits im $t(delivery_notes.delivery_note)",
      performed_by_required:
        "Bitte einen Mitarbeiter (Durchgeführt von) wählen, bevor der Bericht abgeschlossen werden kann.",
      invalid_performed_by_id: "Der ausgewählte Mitarbeiter ist kein Techniker.",
    },
  },

  users: {
    users: "Benutzer",
    user: "Benutzer",
    name: "Name",
    username: "Benutzername",
    email: "E-Mail",
    number: "Nummer",
    active: "Aktiv",
    status: "Status",
    roles: "Rollen",
    role: "Rolle",
    role_names: {
      administrator: "Administrator",
      manager: "Manager",
      technician: "Techniker",
      office: "Büro",
    },
    password: "Passwort",
    send_reset_password: "Passwort zurücksetzen Mail senden",
    reset_password_sent: "E-Mail zum Zurücksetzen des Passworts wurde gesendet",
    reset_password_error: "Fehler beim Senden der E-Mail",
    reset_password_admin_only: "Nur Administratoren können Passwörter zurücksetzen",
    reset_password: "Neues Passwort generieren",
    reset_password_confirm:
      "Soll ein neues Passwort für diesen Benutzer generiert werden? Das bisherige Passwort wird sofort ungültig.",
    reset_password_generated: "Neues Passwort generiert",
    reset_password_warning:
      "Dieses Passwort wird nur einmal angezeigt. Bitte jetzt kopieren und sicher an den Benutzer übergeben.",
    copy_password: "Passwort kopieren",
    password_copied: "Passwort in die Zwischenablage kopiert",
    password_copy_failed: "Passwort konnte nicht kopiert werden",
    login_info: "Login-Info",
    login_count: "Anmeldungen",
    current_login_at: "Aktuelle Anmeldung",
    current_login_ip: "Aktuelle IP",
    last_login_at: "Letzte Anmeldung",
    last_login_ip: "Letzte IP",
    last_seen: "Zuletzt gesehen",
    never_logged_in: "Noch nie angemeldet",
  },

  invoices: {
    number: "Rechnungs Nr.",
  },

  address: {
    name: "Name",
    street: "Straße",
    zip: "Postleitzahl",
    district: "Bezirk",
    city: "Stadt",
    state: "Bundesland",
    country: "Land",
    menu: {
      from: "Von",
      to: "An",
    },
  },

  errors: {
    item: {
      number_exists: "Ein Artikel mit dieser Nummer existiert bereits",
    },
    delivery_note: {
      invalid_transition: "Übergang von {{from}} nach {{to}} ist nicht erlaubt",
      transition_forbidden: "Übergang von {{from}} nach {{to}} ist für Ihre Rolle nicht erlaubt",
    },
    users: {
      already_exists: "Ein Benutzer mit diesem Benutzernamen oder dieser E-Mail existiert bereits",
    },
    user_settings: {
      ineligible_role:
        "Benachrichtigungen können für die Rolle dieses Benutzers nicht aktiviert werden.",
    },
    unknown: "Ein unbekannter Fehler ist aufgetreten",
    types: {
      number: {
        number: "Wert muss einer Zahl entsprechen",
        positive: "Wert muss einer positiven Zahl entsprechen",
      },
    },
  },

  permissions: {
    can_not_edit: "Keine Rechte zum editieren",
  },

  common: {
    back: "Zurück",
    previous: "Zurück",
    next: "Weiter",
    range_from: "ab",
    range_until: "bis",
    position: "Position",
    line: "Pos",
    move_up: "Nach oben verschieben",
    move_down: "Nach unten verschieben",
    create: "Anlegen",
    number_short: "Nr.",
    full_name: "Vollständiger Name",
    name: "Name",
    employee: "Mitarbeiter",
    expert: "Mitarbeiter",
    add: "Hinzufügen",
    remove: "Entfernen",
    edit: "Editieren",
    copy: "Kopieren",
    details: "Details",
    print: "Drucken",
    send_email: "Per E-Mail senden",
    copy_link: "Link kopieren",
    link_copied: "Link wurde in die Zwischenablage kopiert",
    email_sent: "E-Mail wurde versendet",
    email_copy_sent_to: "Kopie an: {{email}}",
    recipient: "Empfänger",
    subject: "Betreff",
    message: "Nachricht",
    send: "Senden",
    attachments: "Anhänge",
    attachments_too_large: "Anhänge überschreiten das Limit von 10 MB",
    select: "Auswählen",
    choose: "Bitte wählen",
    months: "Monate",
    reset: "Zurücksetzten",
    undo: "Rückgängig",
    created_by: "Erstellt von",
    updated_by: "Geändert von",
    on_date: "am",
    lock: "Sperren",
    unlock: "Entsperren",
    cancel: "Abbrechen",
    confirm: "Bestätigen",
    close: "Schließen",
    confirm_unsaved_changes:
      "Es gibt ungespeicherte Änderungen. Möchten Sie die Seite wirklich verlassen?",
    save: "Speichern",
    delete: "Löschen",
    confirm_delete: "Möchten Sie diesen Eintrag wirklich löschen?",
    saved: "Gespeichert",
    deleted: "Gelöscht",
    offline: "Keine Internetverbindung – Speichern ist zurzeit nicht möglich.",
    customer_signed: "Vom Kunden unterschrieben",
    date: {
      from: "vom",
    },
  },

  comments: {
    add: "Kommentar hinzufügen",
    add_placeholder: "Kommentar schreiben...",
    delete: "Kommentar löschen",
    confirm_delete: "Möchten Sie diesen Kommentar wirklich löschen?",
    edited: "bearbeitet",
  },

  files: {
    confirm_delete: "Möchten Sie diese Datei wirklich löschen?",
    attachment_formats: "PDF, JPG, PNG, WebP, HEIC/HEIF",
    drop_hint: "Dateien hier ablegen oder auswählen",
    drop_active: "Dateien zum Hochladen loslassen",
    upload_constraints:
      "{{formats}} · max. {{maxFileSize}} pro Datei · {{maxFiles}} Dateien / {{maxTotalSize}} insgesamt",
    upload_queued: "Wartet auf den Upload",
    upload_progress: "{{progress}} % · {{uploaded}} / {{total}}",
    upload_ready_for_save: "Bereit – wird beim Speichern angehängt",
    upload_failed: "Upload fehlgeschlagen",
    upload_retry: "Erneut versuchen",
    upload_cancel: "Upload abbrechen",
    upload_remove: "Datei entfernen",
    upload_progress_label: "Upload von {{name}}",
    upload_duplicate: "„{{name}}“ wurde bereits ausgewählt.",
    upload_invalid_type: "„{{name}}“ wird nicht unterstützt.",
    upload_invalid_size: "„{{name}}“ ist leer und kann nicht angehängt werden.",
    upload_too_large: "„{{name}}“ überschreitet das Limit von {{maxSize}}.",
    upload_too_many: "Es können höchstens {{maxFiles}} Dateien angehängt werden.",
    upload_total_too_large: "Die Dateien überschreiten zusammen das Limit von {{maxSize}}.",
    preview: "Vorschau",
    preview_file: "Vorschau von {{name}}",
    open: "Öffnen",
    open_file: "{{name}} öffnen",
    download: "Herunterladen",
    download_file: "{{name}} herunterladen",
    delete_file: "{{name}} löschen",
    errors: {
      too_many: "Es können höchstens 20 Dateien angehängt werden.",
      invalid_size: "Eine leere oder ungültig große Datei kann nicht angehängt werden.",
      too_large: "Eine Datei überschreitet das Limit von 25 MB.",
      total_too_large: "Die Dateien überschreiten zusammen das Limit von 100 MB.",
      duplicate_upload: "Eine Datei wurde mehrfach übermittelt.",
      upload_not_found: "Ein Upload ist nicht mehr verfügbar. Bitte wählen Sie die Datei erneut aus.",
      invalid_metadata: "Die Angaben einer Datei sind ungültig. Bitte wählen Sie die Datei erneut aus.",
      size_mismatch: "Die Größe einer Datei stimmt nicht mit dem Upload überein.",
      incomplete_upload: "Eine Datei wurde nicht vollständig hochgeladen.",
      hash_mismatch: "Eine hochgeladene Datei ist beschädigt. Bitte laden Sie sie erneut hoch.",
      invalid_type: "Es können nur PDF- und unterstützte Bilddateien angehängt werden.",
      extension_mismatch: "Dateiendung und Dateiformat stimmen nicht überein.",
    },
  },

  transcription: {
    recording: "Aufnahme läuft...",
    transcribing: "Wird transkribiert...",
    error: "Transkription fehlgeschlagen",
    mic_denied: "Mikrofonzugriff verweigert",
  },

  markdown: {
    preview: "Vorschau",
    edit: "Bearbeiten",
  },

  assistant: {
    button: "Assistent",
    title: "Assistent",
    hint: "Text einfügen – füllt die Felder, bewahrt den Originaltext und erstellt eine Zusammenfassung unter „$t(work_orders.remark)“.",
    placeholder: "Text hier einfügen…",
    process: "Verarbeiten",
    processing: "Wird verarbeitet…",
    errors: {
      unavailable: "Der Assistent ist derzeit nicht verfügbar.",
      not_configured: "Der Assistent ist nicht konfiguriert.",
      nothing_found: "Es konnten keine Daten erkannt werden.",
    },
  },

  inspections: {
    title: "Prüfübersicht",
    month: "Monat",
    year: "Jahr",
    month_invalid: "Ungültiger Monat",
    inspector: "Prüfer",
    customer_nr: "Kundennr.",
    customer: "Kunde",
    property_nr: "Objektnr.",
    property: "Objekt",
    device_type: "Gerätetyp",
    next_inspection: "Nächste Prüfung",
    last_inspection: "Letzte Prüfung",
    schedule: "Termine",
    interval: "Intervall",
    card: "Prüfkarte",
    code: "Code",
    remark: "Bemerkung",
    communications: "Kommunikation",
    medium: "Medium",
    number: "Nummer",
    quantity: "Menge",
    no_results: "Keine Prüfungen gefunden",
    convert: "Als Arbeitsauftrag übernehmen",
    convert_short: "Übernehmen",
    confirm_convert: "Diesen Prüftermin wirklich als Arbeitsauftrag übernehmen?",
    confirm_convert_many:
      "{{count}} Prüftermine wirklich als Arbeitsaufträge übernehmen?",
    select_all: "Alle auswählen",
    converted: "Übernommen",
    filter_converted: "Übernommene",
    filter_unconverted: "Nicht übernommene",
    open_work_order: "$t(work_orders.work_order) öffnen",
    errors: {
      already_converted: "Diese Prüfung wurde bereits als Arbeitsauftrag übernommen.",
      no_due_date: "Diese Prüfung hat kein Fälligkeitsdatum.",
    },
    tunnel_unavailable: "SQLBase ist derzeit nicht erreichbar. Bitte prüfen Sie die Netzwerkverbindung.",
    tab_list: "Liste",
    tab_map: "Karte",
    map_stats: "{{located}} von {{total}} angezeigt — {{unlocated}} Adressen konnten nicht lokalisiert werden",
    map_loading: "Karte wird geladen...",
    map_empty: "Keine Prüfungen für den gewählten Filter vorhanden.",
    map_error: "Kartendaten konnten nicht geladen werden.",
    map_legend: "Legende",
    map_legend_unknown: "Unbekannt",
  },

  nominatim: {
    unavailable:
      "Der Kartendienst ist derzeit nicht erreichbar. " +
      "Adressen können nicht auf der Karte angezeigt werden.",
    unavailable_short: "Kartendienst nicht erreichbar",
  },

  settings: {
    translations: {
      title: "Bezeichnungen",
      description: "Bezeichnungen für Menüpunkte und Formulare anpassen",
      delivery_notes_plural: "Formulare (Plural)",
      delivery_notes_singular: "Formular (Singular)",
      templates_plural: "Vorlagen (Plural)",
      templates_singular: "Vorlage (Singular)",
    },
    natrav: {
      title: "Sichere Verbindung (Tunnel)",
      service: "Service",
      server: "Server",
      token: "Token",
      lokal: "Lokal",
      port: "Port",
      test: "Verbindung testen",
      tunnel_ok: "Tunnel erreichbar",
      tunnel_failed: "Tunnel nicht erreichbar",
    },
    sqlbase: {
      title: "SQLBase",
      db_name: "Datenbankname",
      username: "Benutzername",
      password: "Passwort",
      confirm_overwrite: "Vorhandene Einstellungen überschreiben?",
      test: "Verbindung testen",
      connection_ok: "Datenbankverbindung erfolgreich",
      connection_failed: "Datenbankverbindung fehlgeschlagen",
      authorization_title: "Autorisierung zum lesenden Datenbankzugriff",
      authorization_accept: "Akzeptieren",
      authorization_accepted_by: "Akzeptiert von {{name}} am {{date}} für {{db_name}} ({{version}})",
    },
    imports: {
      title: "Importe",
      tabs: {
        articles: "Artikel",
      },
    },
    article_import: {
      title: "Artikel aus Altsystem importieren",
      description:
        "Pflegt den Artikelstamm aus der Altsystem-Datenbank in das Portal ein. " +
        "Bereits angepasste Felder (Hervorhebung, Charakteristik, Prüfintervall) " +
        "bleiben erhalten.",
      start: "Import jetzt starten",
      running: "Import läuft …",
      started: "Import gestartet",
      already_running: "Es läuft bereits ein Import",
      update_existing: "Bestehende Artikel aktualisieren",
      update_existing_hint:
        "Ist diese Option aktiv, werden Name und Warengruppe bestehender Artikel " +
        "aus dem Altsystem überschrieben. Hervorhebung, Charakteristik und Prüfintervall " +
        "bleiben erhalten. Ohne Häkchen werden bestehende Artikel übersprungen.",
      empty_state:
        "Noch keine Artikel importiert. Klicke auf „Import jetzt starten“, um Daten aus dem Altsystem zu laden.",
      started_at: "Gestartet",
      finished_at: "Beendet",
      duration: "Dauer",
      pages: "Seiten",
      show_errors: "{{count}} Fehler anzeigen",
      counts: {
        created: "Angelegt",
        updated: "Aktualisiert",
        skipped: "Übersprungen",
        errors: "Fehler",
      },
      error: {
        handel_not_configured: "Altsystem-URL ist nicht konfiguriert.",
        sqlbase_not_configured: "SQLBase-Zugangsdaten fehlen.",
      },
    },
  },

  form: {
    errors: {
      required: "{{attr}} is notwendig",
      email: "Bitte eine gültige E-Mail-Adresse eingeben",
    },
  },

  notifications: {
    tab: {
      title: "Benachrichtigungen",
      page_title: "Einstellungen",
      ineligible_placeholder:
        "Benachrichtigungen sind für die aktuelle Rolle nicht verfügbar.",
    },
    fields: {
      email: {
        delivery_note_delivered:
          "E-Mail erhalten, wenn ein $t(delivery_notes.delivery_note) geliefert wird",
      },
    },
    delivery_note_delivered: {
      email: {
        subject: "$t(delivery_notes.delivery_note) Nr. {{number}} wurde geliefert",
        body:
          "Hallo {{recipient_name}},\n\n" +
          "$t(delivery_notes.delivery_note) Nr. {{number}} wurde geliefert.\n\n" +
          "Erstellt von: {{creator}}\n" +
          "Geliefert von: {{actor}}\n" +
          "Kunde: {{customer}}\n" +
          "Objekt: {{property_name}}\n" +
          "Adresse: {{property_address}}\n" +
          "Geliefert am: {{delivered_at}}\n\n" +
          "Direktlink:\n{{link}}\n\n" +
          "Mit freundlichen Grüßen\n\n" +
          "Dein FormWeg.de Team",
      },
    },
  },
};

export default translations;
